import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const IdfcFirstLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. Can I avail of any income tax benefits if I take an education loan from IDFC?",
            content: "If you obtain an education loan from IDFC FIRST Bank, you will qualify for income tax benefits under section 80E."
        },
        {
            title: "2. Do I need to have a co-applicant when applying for a student loan at IDFC FIRST Bank?",
            content: "Yes, to apply for student loans at IDFC FIRST Bank, you must have a co-applicant."
        },
        {
            title: "3. Does IDFC FIRST Bank charge a prepayment penalty for their education loans?",
            content: "There are no pre-payment penalties associated with closing your loan with IDFC FIRST Bank."
        },
        {
            title: "4. Which expenses are included in an IDFC education loan?",
            content: "The expenses that will be paid include the fees for tuition, examinations, library, and laboratory, as well as the purchase of books, equipment, and uniforms. Additionally, living expenses like hostel fees, travel expenses, and health insurance will also be covered."
        }, {
            title: "5. When considering an education loan from IDFC for MS in the US, the preference for a category is given to either the GRE score or the university/college.",
            content: "The category that will be chosen as your final category depends on which option gives you a higher category. For example, if your GRE score places you in the platinum category and your university/college places you in the titanium category, your loan will proceed with the platinum category as your final category."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"IDFC-First Lending Partner"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"IDFC-First Lending Partner"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">IDFC FIRST Education Loan</h5>
                            <p className="loan-elegibility-des">IDFC FIRST Bank offers education loans for studying abroad, with a focus on supporting students at every stage of their journey. The partnership between Credere and IDFC Bank aims to make the admission process stress-free by providing expert guidance and assistance with loan applications and disbursement. The IDFC FIRST Bank’s education loans are thoughtfully crafted to guarantee a seamless and trouble-free experience for students pursuing overseas studies.
                                <br /><br />
                                The loan application process primarily takes place online, but in certain instances, the applicant may need to visit the bank in person to submit the necessary documents and complete the final signing. However, when it comes to IDFC Bank’s education loan for studying abroad, there is a notable difference compared to other private banks.
                                <br /><br />
                                Though, in contrast to other private banks, IDFC Bank’s abroad education loan places more of an emphasis on your educational record than that of any co-applicant.
                                <br /><br />
                                Additionally, IDFC Bank has curated a list of universities and colleges in various countries such as the USA, UK, Australia, Canada, Netherlands, France, and more. These institutes are categorized into three distinct groups by the bank.
                                <br /><br />
                                <b>Platinum &gt; Titanium &gt; Gold</b>
                                <br /><br />
                                This categorization is based only on courses/colleges in Canada and other countries, and it depends on the college/course or GRE score in the US. In some cases, this classification can be dependent on the applicant’s GRE score as well. The table below lists some general characteristics of education loans from IDFC Bank for study abroad.
                                <br /><br />
                                <b>An in-depth Overview IDFC FIRST Overseas Education Loan Program</b></p>
                            <h5 className="about-head">Overview of ICICI's Abroad Education Loan Program</h5>

                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Details	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Maximum age of the applicants</td>
                                        <td className="">

                                            30 years (no experience); 32 years(with experience)
                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">
                                            Up to 50 Lakhs (depending on category and country)

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Interest rate type</td>
                                        <td className="">

                                            Floating

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Interest rate
                                        </td>

                                        <td className="">
                                            Secured loans-9.5%-11.0%<br />
                                            Unsecured loans-10.75%-13.0%</td>

                                    </tr>
                                    <tr>
                                        <td className="">

                                            Loan Tenure</td>
                                        <td className="">

                                            Upto 12 years

                                        </td>


                                    </tr>

                                    <tr>
                                        <td>
                                            Moratorium Period</td>
                                        <td>Course + 12 months</td></tr>
                                    <tr>
                                        <td>Payment during the
                                            moratorium period</td>
                                        <td>All options available: simple interest, partial simple interest, EMI , no payment(depends on profile)</td>
                                    </tr>
                                    <tr>
                                        <td>Processing Time</td>
                                        <td>10-12days(after documents submission)</td>
                                    </tr>
                                    <tr>
                                        <td>Insurance</td>
                                        <td>Credit life insurances</td>
                                    </tr>
                                    <tr>
                                        <td>Tax Benfit</td>
                                        <td>Yes</td>
                                    </tr>
                                    <tr>
                                        <td>Prepayment Penalty</td>
                                        <td>No Penalty</td>
                                    </tr>
                                    <tr>
                                        <td>Margin Money</td>
                                        <td>Nil(may vary depending on your profile)</td>
                                    </tr>
                                </tbody>
                            </table>

                            <h5 className="about-head">Requirements for IDFC FIRST Bank Abroad Education Loan Eligibility</h5>
                            <ol className="subhead-ul">
                                <li>These are some requirements that you need to meet to be eligible for an IDFC Bank loan for overseas education.</li>
                                <li>Both the applicant and co-applicant must be citizens of India.</li>
                                <li>The candidate must be at least eighteen years old.</li>
                                <li>Successfully enrolled in the preferred academic institution following the completion of the necessary prerequisites.</li>
                            </ol>
                            <p className="loan-elegibility-des"><b>Note:</b> A conditional sanction letter may be provided if the admission is not confirmed, depending on the course, country, or institute the student has applied.</p>


                            <h5 className="about-head">IDFC FIRST Bank education loan for MS in the U.S</h5>
                            <p className="loan-elegibility-des">The IDFC Bank loan is crafted specifically for students pursuing a US master’s course in STEM and MBA programs. The categorization of universities/colleges is determined based on the GRE score, as indicated below.</p>

                            <ol className="subhead-ul">
                                <li>If GRE is more than or equal to 315 – Platinum category</li>
                                <li>If GRE is between 300 to 314 then – Titanium category</li>
                                <li>If the GRE is less than 315 – The gold category</li>

                            </ol>
                            <p className="loan-elegibility-des"><b>Note:</b> The loan process will consider the highest category based on the GRE or university/college list. If your GRE scores indicate a Titanium category, but the university/college list classifies you as Platinum, your loan will be processed according to the Platinum category.</p>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">

                            <h5 className="about-head">Additional Aspects of IDFC FIRST Bank Education Loan for MS in US</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Details	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>Maximum loan amount</td>
                                        <td>Platinum-50 Lakhs INR; Titanium - 40 Lakhs INR; Gold - 30 Lakhs INR</td>
                                    </tr>
                                    <tr>
                                        <td>Rate of interest</td>
                                        <td>Platinum-11.50%;Titanium-11.75%;Gold-12.25%</td>
                                    </tr>
                                    <tr>
                                        <td>Processing fees</td>
                                        <td>Platinum-1%+GST; Titanium-1%+ Gold-12.25%+ Gold</td>
                                    </tr>
                                    <tr>
                                        <td>Repayment option during the moratorium</td>
                                        <td>Platinum- Partial Simple Interest (PSI);Titanium - Partial Simple Interest (PSI); Gold - Simple Interest (SI)or EMI</td>
                                    </tr>
                                    <tr>
                                        <td>Eligibility for a full moratorium (no payment during the course and grace period)</td>
                                        <td>Platinum - Yes; Titanium- Yes; Gold-No</td>
                                    </tr>
                                    <tr>
                                        <td>Eligibility for non-financial co-applicant</td>
                                        <td>
                                            Platinum - Yes; Titanium- Yes; Gold-No</td>
                                    </tr>
                                    <tr>
                                        <td>Co-applicant income</td>
                                        <td>Minimum 35,000 INR(without obligations)</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h5 className="about-head">IDFC FIRST Bank Education Loan for MS/PGDM in Canada</h5>
                            <p className="loan-elegibility-des">IDFC FIRST Bank offers an education loan specifically created for international students who wish to pursue their higher education in Canada. This loan is available for those who are interested in pursuing a Master’s or PGDM degree in STEM or management subjects. Similar to the United States, the loan is categorized into three levels: Platinum, Titanium, and Gold. These categories offer different options and benefits to cater to the diverse needs of students.
                                <br /><br />
                                Other features of IDFC FIRST Bank education loan for MS/PGDM in Canada</p>


                            <h5 className="about-head">Auxilo Education Loan for US</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>GRE &gt;=310	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>
                                            Maximum loan amount
                                        </td>
                                        <td>Platinum-35 Lakhs INR; Titanium-30 Lakhs INR; Gold- 25 Lakhs INR</td>
                                    </tr>
                                    <tr>
                                        <td>Rate of interest</td>
                                        <td>Platinum-11.75%; Titanium-12.25% Gold- 13.25%</td>
                                    </tr>
                                    <tr>
                                        <td>Processing fees</td>
                                        <td>Platinum-1%+GST;Titanium-1%+GST; Gold- 1.25%+GST</td>
                                    </tr>
                                    <tr>
                                        <td>Repayment option during the moratorium</td>
                                        <td>Platinum-Partial simple interest(PSI); Titanium - Partial Simple Interest (PSI) or Simple Interest (SI); Gold- EMI</td>
                                    </tr>
                                    <tr>
                                        <td>Eligibility for a full moratorium (no payment during the course and grace period)</td>
                                        <td>Platinum - Yes; Titanium- No; Gold-No</td>
                                    </tr>
                                    <tr>
                                        <td>Eligibility for non-financial co applicants</td>
                                        <td>Platinum - Yes; Titanium- No; Gold-No</td>
                                    </tr>
                                    <tr>
                                        <td>Other eligibility criteria</td>
                                        <td>1. Minimum IELTS score -6.5<br />
                                            2. Maximum backlogs -5<br />
                                            3. Except for the Platinum category, a financial co-applicants is required.<br />
                                            4. Minimum income of co-applicants should be 35,000 INR per month(without obligations)
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="loan-elegibility-des"><b>Note :</b> If the borrower has an excellent profile, which includes factors such as academic performance, target university, co-applicant income, IELTS score, and more, they may be eligible to receive PSI.</p>

                            <h5 className="about-head">Education loan for MS/PGDM from IDFC FIRST Bank for Study Abroad</h5>


                            <p className="loan-elegibility-des">IDFC FIRST Bank provides a loan option that is available for countries other than the two mentioned previously. This loan is accessible to individuals residing in various countries such as the UK, Ireland, Germany, Australia, Sweden, Netherlands, France, and New Zealand.</p>

                            <h5 className="about-head">The Documents Needed to Apply for an Education Loan from IDFC FIRST Bank for Overseas Studies.</h5>

                            <h6 className="subhead mt-4">Documents Required from Applicants</h6>
                            <ol className="subhead-ul">
                                <li>Proof of residence</li>
                                <li>Photo ID proof</li>
                                <li>Proof of admission</li>
                                <li>Passport sized photograph</li>
                                <li>Salary slips (if experienced)</li>
                                <li>Fee structure document</li>
                                <li>Academic documents</li>
                            </ol>
                            <h6 className="subhead">Required Documentation from Co-applicants</h6>
                            <ol className="subhead-ul">
                                <li>Proof of residence</li>
                                <li>Photo ID proof</li>
                                <li>Passport sized photograph</li>
                                <li>Income-related documents (wherever required)</li>
                            </ol>
                            <h5 className="about-head">Credere Assist you in Obtaining your IDFC First Education Loan</h5>
                            <p className="loan-elegibility-des">Credere’s association with IDFC FIRST Bank makes it easier and more convenient to secure an education loan for studying abroad. By choosing their services, you can benefit from a range of perks that enhance your overall loan experience.</p>
                            <h5 className="about-head">Greater Probability of Being Approved</h5>
                            <p className="loan-elegibility-des">By utilizing Credere’s services, you can gain a better understanding of the loan process and the criteria for eligibility, ultimately increasing your chances of being approved. They take the necessary steps to verify your eligibility before forwarding your application to Axis Bank, which increases the possibility of acceptance. </p>
                            <h5 className="about-head">Customized Document Checklist</h5>
                            <p className="loan-elegibility-des">Credere provides customized document checklists tailored to your profile. These checklists include all the necessary documents and alternative options, ensuring that you have a clear understanding of the requirements for your loan application to private banks.</p>
                            <p className="loan-elegibility-des"><b>Transparency in the Process</b></p>
                            <p className="loan-elegibility-des">After your documents are submitted, Credere takes full responsibility for having your loan approved. They also follow up with the bank to guarantee a speedy application procedure.</p>
                            <p className="loan-elegibility-des"><b>Free of Cost Support</b></p>
                            <p className="loan-elegibility-des">Once your eligibility has been verified, Credere provides an Education Loan Counselor (ELC) at no additional cost to help you navigate through the loan process and provide assistance.</p>
                            <p className="loan-elegibility-des"><b>Guaranteed Best Loan</b></p>
                            <p className="loan-elegibility-des">Credere is fully committed to providing you with the most competitive education loan option available. Our primary objective is to guarantee that you receive the most favorable offer. We will make up the difference in interest rates for the whole term of the educational loan if you find a better offer. </p>

                            <h5 className="about-head">Procedure for Applying for an IDFC First Education Loan through Credere</h5>
                            <p className="loan-elegibility-des"><b>Check Your Eligibility</b></p>
                            <p className="loan-elegibility-des">Start by figuring out whether you qualify for an IDFC FIRST Bank abroad education loan by visiting the Credere website or filling out the loan eligibility form. This may involve elements like creditworthiness, educational qualifications, and admission to an authorized university overseas.</p>
                            <p className="loan-elegibility-des"><b>Loan Application Processing</b></p>
                            <p className="loan-elegibility-des">Based on your profile, an Education Loan Counselor (ELC) from Credere will give you a customized document checklist and an explanation of the loan procedure. IDFC FIRST Bank will process your loan application when you submit it and gather the required documents.</p>
                            <p className="loan-elegibility-des"><b>Verification and Submission of Documentation</b></p>
                            <p className="loan-elegibility-des">Please ensure that you gather and submit all the essential documents listed in the checklist, which includes academic records as well as income records. It is important to make sure that these documents are accurate and meet the specific requirements set by IDFC FIRST Bank. Once you have submitted your application, the bank will proceed to verify it by conducting credit checks, assessing financials, reviewing admission details, and considering other relevant information. </p>
                            <p className="loan-elegibility-des"><b>Loan Approval & Disbursal</b></p>
                            <p className="loan-elegibility-des">After the bank has completed all of its work, you will receive a loan approval notification with the authorized amount. If you are pleased with the terms of the agreement, you may sign it to complete the procedure and have the necessary funds issued.</p>
                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default IdfcFirstLendingPartner;